import React from "react";
import { useTranslation } from "react-i18next";
import type { GuesteriaPartnerConnectionStatus } from "@/components/pages/guesteria-partners/utils/guesteriaPartnersModel";

export function GuesteriaPartnerConnectionStatusBadge({
  status,
}: {
  status: GuesteriaPartnerConnectionStatus;
}): React.JSX.Element {
  const { t } = useTranslation();

  if (status === "installed") {
    return (
      <span className="inline-flex min-h-6 shrink-0 items-center justify-center rounded-md border-[0.83px] border-[#49A432]/50 bg-[#49A432]/5 px-2 py-1 text-xs font-normal leading-none text-[#49A432]">
        {t("partners.table.connectionStatusValues.installed")}
      </span>
    );
  }

  return (
    <span className="inline-flex min-h-6 shrink-0 items-center justify-center rounded-md border-[0.83px] border-[#DFAC4F]/50 bg-[#DFAC4F]/5 px-2 py-1 text-xs font-normal leading-none text-[#DFAC4F]">
      {t("partners.table.connectionStatusValues.unavailable")}
    </span>
  );
}
